import { AngularEnvironment } from './angular-environment';

export const environment: AngularEnvironment = {
	name: 'DEV',
	appName: 'Dashboards',
	baseUrl: 'https://dashboard-dev.eforall.org/',
	bodyCssClasses: [],
	frame: 'Dashboard',
	supportsSpanish: false,
	functionUrl: "https://us-central1-eforall-dashboard-dev.cloudfunctions.net/",
	firebaseConfig: {
		apiKey: "AIzaSyAOvTvUD04K89ylo408mOqIFfIBwbz5yH8",
		authDomain: "dashboard-dev.eforall.org",
		projectId: "eforall-dashboard-dev",
		storageBucket: "eforall-dashboard-dev.appspot.com",
		messagingSenderId: "703689357484",
		appId: "1:703689357484:web:1aa3007ea47a3057554709",
		measurementId: "G-QP4G9LV7XN",
	},
};
